<footer class="inner-page-footer" role="contentinfo">
  <div class="container">
    <div class="footer-content">
      <div class="logo-section">
        <span class="powered-txt">Powered By</span>
        <app-svg-icon
          [iconName]="'footer-logo.svg'"
          [height]="'98px'"
          [width]="'92px'"
          aria-hidden="true"
          class="logo-icon"
        ></app-svg-icon>
      </div>
      <div class="divider"></div>
      <nav
        class="links-section"
        role="navigation"
        aria-label="Footer Navigation"
      >
        <a
          [routerLink]="'/privacy-policy'"
          href="javascript:void(0)"
          aria-label="Privacy Policy"
          class="footer-link"
          target="_blank"
          >Privacy Policy</a
        >
        <a
          [routerLink]="'/terms-of-use'"
          href="javascript:void(0)"
          aria-label="Terms of Use"
          class="footer-link"
          target="_blank"
          >Terms of Use</a
        >
      </nav>
    </div>
  </div>
</footer>
